import qs from 'qs';
import { isCloud } from '../helpers/isCloud';
import { HttpClient } from './AxiosHttpClient';
export class StaffWidgetsClient {
    getUrl() {
        return `https://api.${isCloud() ? 'test' : ''}kontur.ru/staff-widgets/`;
    }
    constructor(options) {
        Object.defineProperty(this, "client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.client = new HttpClient(options?.url || this.getUrl());
    }
    getFeatureFlags() {
        return this.client.get('/feature-flags');
    }
    getWidgetsEnvironmentsInfo() {
        return this.client.get('/environments');
    }
    getWidgetsAssetsInfo() {
        return this.client.get('/assets');
    }
    async postFeedback(feedback) {
        await this.client.post(`/feedback`, feedback);
    }
    async getStaffReport(employerId, employeeIds) {
        const params = qs.stringify({ employerId, employeeIds }, { arrayFormat: 'repeat' });
        return this.client.get(`/reports/staff-report?${params}`);
    }
    getSettings() {
        return this.client.get('/settings');
    }
    patchSettings({ name, value }) {
        return this.client.patch(`/settings/${name}`, { value });
    }
}
